import {langCode} from "../languages/langugase";


export  const  currentLang = (href)=>{
    return langCode.find(l => href.includes(l))
}

